import React, { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Clock, Timer } from "lucide-react";

const DAYS = [["seg", "Segunda"], ["ter", "Terça"], ["qua", "Quarta"], ["qui", "Quinta"], ["sex", "Sexta"], ["sab", "Sábado"], ["dom", "Domingo"]];

export const HoursCard = ({ s, update }) => {
  const [hours, setHours] = useState(s.business_hours);
  const [text, setText] = useState(s.offhours_text);
  const setDay = (d, patch) => setHours({ ...hours, [d]: { ...hours[d], ...patch } });

  return (
    <Card data-testid="hours-card"><CardContent className="p-5 space-y-4">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-xl bg-emerald-100 dark:bg-emerald-950 flex items-center justify-center text-emerald-700 dark:text-emerald-200 shrink-0"><Clock className="w-5 h-5" /></div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold">Horário de atendimento</div>
          <div className="text-sm text-muted-foreground mt-0.5">Fora do expediente (horário de Brasília), o cliente recebe automaticamente a mensagem abaixo, no máximo uma vez a cada 6 horas.</div>
        </div>
        <Switch checked={!!s.hours_enabled} onCheckedChange={(v) => update({ hours_enabled: v })} data-testid="settings-hours-toggle" />
      </div>
      <div className="space-y-2">
        {DAYS.map(([d, label]) => (
          <div key={d} className="flex flex-wrap items-center gap-3" data-testid={`hours-day-${d}`}>
            <Switch checked={!!hours[d]?.open} onCheckedChange={(v) => setDay(d, { open: v })} data-testid={`hours-open-${d}`} />
            <span className="w-20 text-sm font-medium">{label}</span>
            {hours[d]?.open ? (
              <>
                <Input type="time" value={hours[d].start} onChange={(e) => setDay(d, { start: e.target.value })} className="h-9 w-28" data-testid={`hours-start-${d}`} />
                <span className="text-xs text-muted-foreground">até</span>
                <Input type="time" value={hours[d].end} onChange={(e) => setDay(d, { end: e.target.value })} className="h-9 w-28" data-testid={`hours-end-${d}`} />
              </>
            ) : <span className="text-xs text-muted-foreground">Fechado</span>}
          </div>
        ))}
      </div>
      <div>
        <Label className="text-xs">Mensagem fora do horário (use {"{empresa}"} e {"{cliente}"})</Label>
        <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} className="mt-1" data-testid="settings-offhours-text" />
      </div>
      <Button size="sm" variant="outline" onClick={() => update({ business_hours: hours, offhours_text: text })} data-testid="settings-hours-save">Salvar horários e mensagem</Button>
    </CardContent></Card>
  );
};

export const WaitAlertCard = ({ s, update }) => {
  const [min, setMin] = useState(s.wait_alert_minutes ?? 10);
  return (
    <Card data-testid="wait-alert-card"><CardContent className="p-5 flex flex-wrap items-center gap-4">
      <div className="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-950 flex items-center justify-center text-orange-700 dark:text-orange-200 shrink-0"><Timer className="w-5 h-5" /></div>
      <div className="flex-1 min-w-[220px]">
        <div className="font-semibold">Alerta de espera</div>
        <div className="text-sm text-muted-foreground mt-0.5">Os administradores recebem alerta sonoro e visual quando um contato fica sem resposta por mais tempo que o definido. 0 desativa.</div>
      </div>
      <div className="flex items-center gap-2">
        <Input type="number" min="0" max="1440" value={min} onChange={(e) => setMin(e.target.value)} className="h-9 w-20" data-testid="settings-wait-minutes" />
        <span className="text-sm text-muted-foreground">min</span>
        <Button size="sm" variant="outline" onClick={() => update({ wait_alert_minutes: parseInt(min, 10) || 0 })} data-testid="settings-wait-save">Salvar</Button>
      </div>
    </CardContent></Card>
  );
};
